module.exports = __webpack_public_path__ + "img/rule2.103ff191.png";